/**
 * @generated SignedSource<<bb3b4dedbc154c45c4338ef30525bfbd>>
 * @relayHash e0f06b3a0f9d0dc350a88d69c22d4ee2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 11a77c767341aa2ca2480103f304a876a2c3b469f1174a8b1d9f157305f7a780

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSpaPageContainerQuery$variables = {
  cloudId: string;
};
export type JiraSpaPageContainerQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BannerContent">;
};
export type JiraSpaPageContainerQuery = {
  response: JiraSpaPageContainerQuery$data;
  variables: JiraSpaPageContainerQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcbannerannouncementviasparelayprovider": bannerAnnouncementViaSpa_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcbannerannouncementviasparelayprovider: {
    readonly get: () => boolean;
  };
});

import bannerAnnouncementViaSpa_provider from '@jira/platform__graphql-relay-provider/src/banner-announcement-via-spa.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JiraSpaPageContainerQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "BannerContent"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcbannerannouncementviasparelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "JiraSpaPageContainerQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcbannerannouncementviasparelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                  }
                ],
                "concreteType": "JiraAnnouncementBanner",
                "kind": "LinkedField",
                "name": "announcementBanner",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isDismissible"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "visibility"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "11a77c767341aa2ca2480103f304a876a2c3b469f1174a8b1d9f157305f7a780",
    "metadata": {},
    "name": "JiraSpaPageContainerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcbannerannouncementviasparelayprovider": bannerAnnouncementViaSpa_provider
    }
  }
};
})();

(node as any).hash = "cceab149c27c13616adc23f0556d61ac";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
